import {durationToString} from '@wix/music-shared/dist/src/utils/time/time';
import PropTypes from 'prop-types';
import React from 'react';
import {AnyToDo} from '../../../typings/todo';
import {withTrackFont} from '../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../services/env/siteSettings/fonts/fonts';
import styles from './Duration.scss';

class DurationComponent extends React.Component<AnyToDo> {
  static propTypes = {
    trackFont: PropTypes.object,
    duration: PropTypes.number.isRequired,
    progress: PropTypes.number,
  };
  static defaultProps = {
    progress: 0,
  };

  render() {
    const {duration, progress, trackFont} = this.props;
    return (
      <div className={styles.duration} data-hook="playerDuration" style={withoutSize(trackFont)} aria-hidden>
        {durationToString(duration * progress)} / {durationToString(duration)}
      </div>
    );
  }
}

export const Duration = withTrackFont(DurationComponent);
